import { trace } from './log';
export var ServerType;
(function (ServerType) {
    ServerType["WORKER"] = "queue_0";
    ServerType["FRONT"] = "front";
})(ServerType || (ServerType = {}));
(function (ServerType) {
    function defaultFolderName(type) {
        switch (type) {
            case ServerType.WORKER:
                return 'queue_0'; // FIXME: temporary hack until multiple workers are fully supported
            case ServerType.FRONT:
                return 'front';
        }
    }
    ServerType.defaultFolderName = defaultFolderName;
    function defaultName(type) {
        switch (type) {
            case ServerType.WORKER:
                return 'queue_0'; // FIXME: temporary hack until multiple workers are fully supported
            case ServerType.FRONT:
                return 'front';
        }
    }
    ServerType.defaultName = defaultName;
})(ServerType || (ServerType = {}));
export class LocalServerRegistry {
    constructor() {
        this.servers = {};
    }
    register(name, info) {
        trace('register', name, info);
        this.servers[name] = info;
    }
    getServerInfo(name) {
        return this.servers[name];
    }
    getServers(type) {
        const filtered = {};
        for (let name in this.servers) {
            const s = this.servers[name];
            if (s != null && s.type === type) {
                filtered[name] = s;
            }
        }
        return filtered;
    }
}
//# sourceMappingURL=server-registry.js.map